/* =========================================================================
   Service paragraph — scroll-reveal word animation
   - Splits the paragraph text into individual words wrapped in spans
   - Uses IntersectionObserver so the animation REPLAYS every time the
     section re-enters the viewport (scroll down → leave → scroll back up)
   ========================================================================= */
(function () {
  "use strict";

  var SECTION_SELECTOR = ".service-para";
  var PARA_SELECTOR    = ".services-para";

  function splitWords(paraEl) {
    if (paraEl.dataset.spSplit === "1") return;

    var raw = paraEl.textContent.replace(/\s+/g, " ").trim();
    if (!raw) return;

    var words = raw.split(" ");
    var frag = document.createDocumentFragment();

    words.forEach(function (word, i) {
      var outer = document.createElement("span");
      outer.className = "sp-word";
      outer.style.setProperty("--sp-i", i);

      var inner = document.createElement("span");
      inner.className = "sp-word-inner";
      inner.textContent = word;

      outer.appendChild(inner);
      frag.appendChild(outer);

      if (i < words.length - 1) {
        frag.appendChild(document.createTextNode(" "));
      }
    });

    paraEl.textContent = "";
    paraEl.appendChild(frag);
    paraEl.dataset.spSplit = "1";
  }

  function initSection(section) {
    var para = section.querySelector(PARA_SELECTOR);
    if (!para) return;

    splitWords(para);

    if (!("IntersectionObserver" in window)) {
      section.classList.add("is-in-view");
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // If class is still present from a previous cycle, strip it
          // and force a reflow so the staggered transition replays fresh.
          if (section.classList.contains("is-in-view")) {
            section.classList.remove("is-in-view");
            // eslint-disable-next-line no-unused-expressions
            void section.offsetWidth;
          }
          section.classList.add("is-in-view");
        } else {
          // Snap back to hidden (no out-animation thanks to CSS) so the
          // next entry always starts from a clean baseline.
          section.classList.remove("is-in-view");
        }
      });
    }, {
      threshold: [0, 0.15, 0.5],
      rootMargin: "0px 0px -10% 0px"
    });

    io.observe(section);
  }

  function init() {
    var sections = document.querySelectorAll(SECTION_SELECTOR);
    if (!sections.length) return;
    sections.forEach(initSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
